import{G as a}from"../../style-a86d5d52.js";var e=a.metadata["gfw:basemap-layers"];export default e;
